// Parse links only: never fetch or resolve user-provided URLs on the server.
export function youtubeVideoId(value) {
  if (typeof value !== 'string' || value.length > 2048) return null;
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    let id;
    if (url.hostname === 'youtu.be') id = /^\/([\w-]{11})\/?$/.exec(url.pathname)?.[1];
    else if (['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(url.hostname)) {
      id =
        url.pathname === '/watch'
          ? url.searchParams.get('v')
          : /^\/(?:embed|shorts)\/([\w-]{11})\/?$/.exec(url.pathname)?.[1];
    } else if (url.hostname === 'www.youtube-nocookie.com')
      id = /^\/embed\/([\w-]{11})\/?$/.exec(url.pathname)?.[1];
    return typeof id === 'string' && /^[\w-]{11}$/.test(id) ? id : null;
  } catch {
    return null;
  }
}
